import buildGqlQuery from "ra-data-graphql-simple/lib/buildGqlQuery";
import { DELETE } from "ra-core";
import * as gqlTypes from 'graphql-ast-types-browser';
import { buildApolloArgs, buildArgs } from "ra-data-graphql-simple/src/buildGqlQuery";

const query = introspectionResults => (
    resource,
    aorFetchType,
    queryType,
    variables
) => {
    if (aorFetchType === DELETE) {
        const apolloArgs = buildApolloArgs(queryType, variables);
        const args = buildArgs(queryType, variables);

        return gqlTypes.document([
            gqlTypes.operationDefinition(
                'mutation',
                gqlTypes.selectionSet([
                    gqlTypes.field(
                        gqlTypes.name(queryType.name),
                        gqlTypes.name('data'),
                        args,
                        null,

                    ),
                ]),
                gqlTypes.name(queryType.name),
                apolloArgs
            ),
        ]);
    }

    return buildGqlQuery(introspectionResults)(resource, aorFetchType, queryType, variables);
}

export default query;